package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.kotlin_api

import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class KotlinGQLResponse<T>(
    val data: T? = null,
    val errors: List<GeneralError?>? = null
)